export default __webpack_public_path__ + "static/media/light_blue_mark_icon.6623abb0.svg";